import { Widget, WidgetProps } from "@rjsf/utils";
import React, { useContext, useEffect } from "react";

import { LimitContext } from "../context/LimitContext";

export const LimitedCheckboxWidget: Widget = (props: WidgetProps) => {
  const limitId = props.id.replace("root_", "");
  const limits = useContext(LimitContext);
  const limit = limits.filter((limit) => limit.property === limitId).pop();

  useEffect(() => {
    if (limit === undefined || limit.available <= 0) {
      props.onChange(false);
    }
  }, [props.value, limit]);

  return (
    <div className={"form-check"}>
      <label className={"control-label"}>
        <input
          className={"limited-checkbox"}
          disabled={limit === undefined || limit.available <= 0}
          type="checkbox"
          checked={props.value ?? false}
          required={props.required}
          onChange={(event) => {
            props.onChange(event.currentTarget.checked);
          }}
        />
        <span>
          <span style={{ display: "inline-block", marginLeft: 5 }} className={"limited-checkbox-label"}>
            {props.label}
          </span>
          <span style={{ display: "inline-block", marginLeft: 5 }} className={"limited-checkbox-limit"}>
            ({limit === undefined ? "Freie Plätze werden geladen" : `${limit.available} freie Plätze`})
          </span>
        </span>
      </label>
    </div>
  );
};
